import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStakeDebit } from "../../CustomHooks/Queries";

import { shouldShowMigrationAcknowledgementFromStakeDebitResponse } from "../../Utils/helpers";

import { StakeLogo } from "../../Assets/Images";

export default function BankMigrationSettingUp() {
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const { refetch: refetchStakeDebit } = useStakeDebit({ enabled: false });

  useEffect(() => {
    let isMounted = true;

    const runLoaderAndRedirect = async () => {
      await new Promise((resolve) => {
        window.setTimeout(resolve, 3000);
      });

      if (!isMounted) return;

      try {
        const { data: stakeDebitResponse } = await refetchStakeDebit();
        const stakeDebitStatus = stakeDebitResponse?.data?.data?.status;

        if (shouldShowMigrationAcknowledgementFromStakeDebitResponse(stakeDebitResponse)) {
          navigate("/bank-migration-acknowledgement", { replace: true });
          return;
        }

        if (stakeDebitStatus === "DepositAccountCreated") {
          navigate("/bank-migration-status", { replace: true });
          return;
        }

        navigate("/home", { replace: true });
        return;
      } catch {
        navigate(locationState?.nextPathname || "/home", { replace: true });
      }
    };

    runLoaderAndRedirect();

    return () => {
      isMounted = false;
    };
  }, [locationState?.nextPathname, navigate, refetchStakeDebit]);

  return (
    <div className="onboarding-page sso-page bank-migration-setting-up">
      <div className="setting-up-account">
        <StakeLogo className="migration-logo" />
        <h4 className="loader-title">Migrating your account</h4>
        <p className="loader-description">Securely migrating your account. This usually takes less than a minute.</p>
        <div className="migration-progress-track">
          <div className="migration-progress-fill" />
        </div>
      </div>
    </div>
  );
}
